/**
 * Surah names as the Revision buildings are named (data/surahs.json), index 0 =
 * surah 1. A building holding part of a surah is named "<name> <from>–<to>".
 */
export const SURAH_NAMES = [
    'Al-Fātiḥah',
    'Al-Baqarah',
    'Āl ʿImrān',
    'An-Nisāʾ',
    'Al-Māʾidah',
    'Al-Anʿām',
    'Al-Aʿrāf',
    'Al-Anfāl',
    'At-Tawbah',
    'Yūnus',
    'Hūd',
    'Yūsuf',
    'Ar-Raʿd',
    'Ibrāhīm',
    'Al-Ḥijr',
    'An-Naḥl',
    'Al-Isrāʾ',
    'Al-Kahf',
    'Maryam',
    'Ṭā Hā',
    'Al-Anbiyāʾ',
    'Al-Ḥajj',
    'Al-Muʾminūn',
    'An-Nūr',
    'Al-Furqān',
    'Ash-Shuʿarāʾ',
    'An-Naml',
    'Al-Qaṣaṣ',
    'Al-ʿAnkabūt',
    'Ar-Rūm',
    'Luqmān',
    'As-Sajdah',
    'Al-Aḥzāb',
    'Sabaʾ',
    'Fāṭir',
    'Yā Sīn',
    'Aṣ-Ṣāffāt',
    'Ṣād',
    'Az-Zumar',
    'Ghāfir',
    'Fuṣṣilat',
    'Ash-Shūrā',
    'Az-Zukhruf',
    'Ad-Dukhān',
    'Al-Jāthiyah',
    'Al-Aḥqāf',
    'Muḥammad',
    'Al-Fatḥ',
    'Al-Ḥujurāt',
    'Qāf',
    'Adh-Dhāriyāt',
    'Aṭ-Ṭūr',
    'An-Najm',
    'Al-Qamar',
    'Ar-Raḥmān',
    'Al-Wāqiʿah',
    'Al-Ḥadīd',
    'Al-Mujādilah',
    'Al-Ḥashr',
    'Al-Mumtaḥanah',
    'Aṣ-Ṣaff',
    'Al-Jumuʿah',
    'Al-Munāfiqūn',
    'At-Taghābun',
    'Aṭ-Ṭalāq',
    'At-Taḥrīm',
    'Al-Mulk',
    'Al-Qalam',
    'Al-Ḥāqqah',
    'Al-Maʿārij',
    'Nūḥ',
    'Al-Jinn',
    'Al-Muzzammil',
    'Al-Muddaththir',
    'Al-Qiyāmah',
    'Al-Insān',
    'Al-Mursalāt',
    'An-Nabaʾ',
    'An-Nāziʿāt',
    'ʿAbasa',
    'At-Takwīr',
    'Al-Infiṭār',
    'Al-Muṭaffifīn',
    'Al-Inshiqāq',
    'Al-Burūj',
    'Aṭ-Ṭāriq',
    'Al-Aʿlā',
    'Al-Ghāshiyah',
    'Al-Fajr',
    'Al-Balad',
    'Ash-Shams',
    'Al-Layl',
    'Aḍ-Ḍuḥā',
    'Ash-Sharḥ',
    'At-Tīn',
    'Al-ʿAlaq',
    'Al-Qadr',
    'Al-Bayyinah',
    'Az-Zalzalah',
    'Al-ʿĀdiyāt',
    'Al-Qāriʿah',
    'At-Takāthur',
    'Al-ʿAṣr',
    'Al-Humazah',
    'Al-Fīl',
    'Quraysh',
    'Al-Māʿūn',
    'Al-Kawthar',
    'Al-Kāfirūn',
    'An-Naṣr',
    'Al-Masad',
    'Al-Ikhlāṣ',
    'Al-Falaq',
    'An-Nās',
];
/** Ayahs in each surah, index 0 = surah 1 (data/surahs.json). */
export const SURAH_AYAHS = [7, 286, 200, 176, 120, 165, 206, 75, 129, 109, 123, 111, 43, 52, 99, 128, 111, 110, 98, 135, 112, 78, 118, 64, 77, 227, 93, 88, 69, 60, 34, 30, 73, 54, 45, 83, 182, 88, 75, 85, 54, 53, 89, 59, 37, 35, 38, 29, 18, 45, 60, 49, 62, 55, 78, 96, 29, 22, 24, 13, 14, 11, 11, 18, 12, 12, 30, 52, 52, 44, 28, 28, 20, 56, 40, 31, 50, 40, 46, 42, 29, 19, 36, 25, 22, 17, 19, 26, 30, 20, 15, 21, 11, 8, 8, 19, 5, 8, 8, 11, 11, 8, 3, 9, 5, 4, 7, 3, 6, 3, 5, 4, 5, 6];
/**
 * Pages each surah is printed across in the standard 604-page Madani mushaf,
 * counting a page it shares with a neighbour (index 0 = surah 1). Taken from
 * Tajwid's surah start pages and which surahs open a fresh page.
 */
export const SURAH_PAGES = [1, 48, 27, 30, 22, 23, 26, 10, 21, 14, 15, 14, 7, 7, 6, 15, 12, 12, 8, 10, 10, 10, 8, 10, 8, 10, 9, 12, 9, 7, 4, 3, 10, 7, 7, 6, 7, 6, 10, 10, 6, 7, 7, 3, 4, 5, 4, 5, 3, 3, 4, 3, 3, 4, 4, 4, 5, 4, 4, 3, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 2, 2, 2, 3, 2, 3, 2, 2, 2, 1, 1, 1, 3, 1, 1, 1, 2, 1, 2, 1, 1, 2, 1, 1, 1, 1, 1, 2, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
const surahByName = new Map(SURAH_NAMES.map((name, i) => [name, i + 1]));
/** "Al-Baqarah 142–252" → 2. */
export function surahOfBuilding(name) {
    return surahByName.get(name.replace(/ \d+–\d+$/, '')) ?? null;
}
//# sourceMappingURL=quran.js.map